import { render, staticRenderFns } from "./TrialCategoryResult.vue?vue&type=template&id=1c76c805&scoped=true"
import script from "./TrialCategoryResult.vue?vue&type=script&lang=js"
export * from "./TrialCategoryResult.vue?vue&type=script&lang=js"
import style0 from "./TrialCategoryResult.vue?vue&type=style&index=0&id=1c76c805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c76c805",
  null
  
)

export default component.exports